// extracted by mini-css-extract-plugin
export default {"faqAppPage":"faqAppPage_USxIE","container":"container_UMEcJ","breadcrumbs":"breadcrumbs_nKQT5"};